module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-import-icon.3370ff3d.svg";